import 'tslib';
import { fitCoordinates } from '../service/fitCoordinates.js';
import { fitVisibleArea } from '../service/fitVisibleArea.js';

function reconcileState(state, settings) {
    return fitCoordinates(fitVisibleArea(state, settings), settings);
}

export { reconcileState };
